import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

type Props = {
  title: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  headerClassName?: string;
};

export default function SectionCard({ title, action, children, className, contentClassName, headerClassName }: Props) {
  return (
    <Card className={cn('gap-4 py-6', className)}>
      <CardHeader className={cn('flex items-center justify-between gap-2 px-6', headerClassName)}>
        <CardTitle className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          {title}
        </CardTitle>
        {action}
      </CardHeader>
      <CardContent className={cn('px-6', contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}
